<div class="fslfooter">
    <div class="fxg-wrapper2">
        <div class="row">
            <div class="col-md-4 col-sm-12">
                <div class="title section">
                    <div class="fxg-title fxg-title--default">&copy;
                        <span class="fdx-c-content">
                            {{"COMMON.CommonFooterTitle_Fedex19952021" | translate: {Default: "FedEx 1995-2021"} }}
                        </span>
                    </div>
                </div>
            </div>
            <div class="col-md-8 col-sm-12">
                <div class="text-right text-left-at-md marg-top-at-md">
                    <div class="link">
                        <a href="https://www.fedex.com/en-us/sitemap.html" target="_self">
                            {{"COMMON.CommonFooterHlink_Sitemap" | translate: {Default: "Site Map"} }}
                        </a> <span class="link__separator"> | </span>
                    </div>
                    <div class="link">
                        <a href="https://www.fedex.com/en-us/terms-of-use.html" target="_self">
                            {{"COMMON.CommonFooterHlink_Termsofuse" | translate: {Default: "Terms of Use"} }}
                        </a> <span class="link__separator"> | </span>
                    </div>
                    <div class="link">
                        <a href="https://www.fedex.com/en-us/trust-center.html" target="_self">
                            {{"COMMON.CommonFooterHlink_Privacysecurity" | translate: {Default: "Privacy Security"} }}
                        </a>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>